define(["exports", "react", "moment", "react-intl-universal", "styled-components", "../../atoms/Typography", "../../atoms"], function (_exports, _react, _moment, _reactIntlUniversal, _styledComponents, _Typography, _atoms) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

  var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _react = _interopRequireWildcard(_react);
  _moment = _interopRequireDefault(_moment);
  _reactIntlUniversal = _interopRequireDefault(_reactIntlUniversal);
  _styledComponents = _interopRequireDefault(_styledComponents);

  var EducationItem = _styledComponents.default.div.withConfig({
    displayName: "Education__EducationItem",
    componentId: "sc-19650te-0"
  })(["display:flex;width:100%;+ div{padding:32px 0 0;}"]);

  var IconBuilding = _styledComponents.default.span.withConfig({
    displayName: "Education__IconBuilding",
    componentId: "sc-19650te-1"
  })(["background:", ";border:solid 1px ", ";padding:15px;margin-right:16px;max-height:56px;box-icon{display:block;fill:", ";}"], function (_ref) {
    var theme = _ref.theme;
    return theme.colors.white;
  }, function (_ref2) {
    var theme = _ref2.theme;
    return theme.colors.lightGray;
  }, function (_ref3) {
    var theme = _ref3.theme;
    return theme.colors.dark;
  });

  var EducationCourse = (0, _styledComponents.default)(_Typography.H3).withConfig({
    displayName: "Education__EducationCourse",
    componentId: "sc-19650te-2"
  })(["font-weight:", ";margin:0;"], function (_ref4) {
    var theme = _ref4.theme;
    return theme.font.semibold;
  });
  var TitleBox = (0, _styledComponents.default)(_Typography.H2).withConfig({
    displayName: "Education__TitleBox",
    componentId: "sc-19650te-3"
  })(["margin:0 0 16px;span{color:", ";display:block;font-size:0.7em;font-weight:", ";}"], function (_ref5) {
    var theme = _ref5.theme;
    return theme.colors.darkGray;
  }, function (_ref6) {
    var theme = _ref6.theme;
    return theme.font.regular;
  });
  var EducationText = (0, _styledComponents.default)(_Typography.Small).withConfig({
    displayName: "Education__EducationText",
    componentId: "sc-19650te-4"
  })(["display:block;line-height:24px;margin:0 0 8px;padding:0;"]);
  var EducationDate = (0, _styledComponents.default)(_Typography.Small).withConfig({
    displayName: "Education__EducationDate",
    componentId: "sc-19650te-5"
  })(["font-weight:", ";margin:0;padding:0 0 0 24px;position:relative;@media print{color:", ";font-weight:", ";}box-icon{fill:", ";height:16px;left:0;position:absolute;top:2px;width:16px;}"], function (_ref7) {
    var theme = _ref7.theme;
    return theme.font.semibold;
  }, function (_ref8) {
    var theme = _ref8.theme;
    return theme.colors.dark;
  }, function (_ref9) {
    var theme = _ref9.theme;
    return theme.font.bold;
  }, function (_ref10) {
    var theme = _ref10.theme;
    return theme.colors.dark;
  });

  var SchoolName = _styledComponents.default.span.withConfig({
    displayName: "Education__SchoolName",
    componentId: "sc-19650te-6"
  })(["display:inline-block;width:100%;"]);

  var Education = function Education(_ref11) {
    var educationList = _ref11.educationList,
        level = _ref11.level;
    return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement(TitleBox, null, _reactIntlUniversal.default.get('CURRICULUM.FORMACAO_ACADEMICA.TITULO'), /*#__PURE__*/_react.default.createElement(_atoms.ContentCheck, {
      check: level
    }, /*#__PURE__*/_react.default.createElement("span", null, _reactIntlUniversal.default.get('CURRICULUM.FORMACAO_ACADEMICA.NIVEL'), " ", level))), educationList.map(function (item, index) {
      return /*#__PURE__*/_react.default.createElement(EducationItem, {
        key: index
      }, /*#__PURE__*/_react.default.createElement(IconBuilding, null, /*#__PURE__*/_react.default.createElement("box-icon", {
        name: "graduation",
        type: "solid"
      })), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(EducationCourse, null, item.curso), /*#__PURE__*/_react.default.createElement(EducationText, null, /*#__PURE__*/_react.default.createElement(SchoolName, null, item.instituicao, "(", /*#__PURE__*/_react.default.createElement(_atoms.ContentCheck, {
        check: item.estado
      }, item.estado, ", "), /*#__PURE__*/_react.default.createElement(_atoms.ContentCheck, {
        check: item.pais
      }, item.pais), ")"), /*#__PURE__*/_react.default.createElement("span", null, item.tipo, /*#__PURE__*/_react.default.createElement(_atoms.ContentCheck, {
        check: item.classificacao_do_curso
      }, ' ', "- ", item.classificacao_do_curso), /*#__PURE__*/_react.default.createElement(_atoms.ContentCheck, {
        check: item.area_da_pos
      }, ", ", item.area_da_pos))), /*#__PURE__*/_react.default.createElement(_atoms.ContentCheck, {
        check: item.data_de_conclusao || item.situacao
      }, /*#__PURE__*/_react.default.createElement(EducationDate, null, /*#__PURE__*/_react.default.createElement("box-icon", {
        name: "time"
      }), _reactIntlUniversal.default.get("CURRICULUM.STATUS_CURSOS." + item.situacao), item.situacao !== 'interrompido' && (0, _moment.default)(item.data_de_conclusao).format('MMMM [de] YYYY')))));
    }));
  };

  Education.defaultProps = {
    educationList: []
  };
  var _default = Education;
  _exports.default = _default;
});